import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {HandoverModel} from "@handover/view-models/handover.model";

@Component({
  selector: 'handoverm-handover-statement',
  templateUrl: './handover-statement.component.html',
  styleUrls: ['./handover-statement.component.scss']
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class HandoverStatementComponent implements OnInit {

  @Input() model?: HandoverModel;

  get hasStatement(): boolean {
    return this.model?.statement != null && this.model?.statement.length > 0;
  }

  constructor() {
  }

  ngOnInit(): void {
  }

}
